import { SafetySummary, SafetyTrendPoint, SafetyEventItem } from '@app/core/api/safety-analytics';

/**
 * Safety analytics state interface for NgRx store
 */
export interface SafetyAnalyticsState {
  summary: SafetySummary | null;
  trend: SafetyTrendPoint[];
  events: SafetyEventItem[];
  eventsTotal: number;
  loading: boolean;
  error: string | null;
}

/**
 * Initial state for safety analytics feature
 */
export const initialSafetyAnalyticsState: SafetyAnalyticsState = {
  summary: null,
  trend: [],
  events: [],
  eventsTotal: 0,
  loading: false,
  error: null
};
